import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mantine/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthError {
  message?: string;
  [key: string]: any;
}

export default function LoginButton() {
  const { loginWithRedirect, isAuthenticated, isLoading, error, getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      console.error('Auth0 Error:', error);
      // Check if the error is related to token expiration
      if (
        error.message?.includes('invalid_token') ||
        error.message?.includes('expired') ||
        error.message?.includes('login_required') ||
        error.message?.includes('Missing Refresh Token')
      ) {
        navigate('/logout');
      }
    }
  }, [error, navigate]);

  // Set up token refresh monitoring
  useEffect(() => {
    if (isAuthenticated) {
      const checkToken = async () => {
        try {
          await getAccessTokenSilently();
        } catch (err) {
          const error = err as AuthError;
          console.error('Token refresh error:', error);
          navigate('/logout');
        }
      };

      // Check token validity immediately
      checkToken();

      // Set up periodic token checks (every 5 minutes)
      const interval = setInterval(checkToken, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, getAccessTokenSilently, navigate]);

  if (error) {
    return (
      <Button color="red" variant="light" onClick={() => window.location.reload()}>
        Auth Error - Click to Retry
      </Button>
    );
  }

  if (isLoading) {
    return <Button loading>Loading...</Button>;
  }

  if (isAuthenticated) {
    return (
      <Button onClick={() => navigate('/logout')} variant="light" color="red">
        Log Out
      </Button>
    );
  }

  return (
    <Button onClick={() => loginWithRedirect()} variant="filled" color="blue">
      Log In
    </Button>
  );
}
